import { Container, Row, Col, Card, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import './Home.css'

const Home = () => {
  const { isAuthenticated } = useAuth()

  const features = [
    {
      icon: '🔐',
      title: 'Seguridad',
      description: 'Autenticación, autorización y auditoría',
    },
    {
      icon: '👥',
      title: 'Clientes',
      description: 'Gestión de clientes (Personas Físicas/Morales)',
    },
    {
      icon: '📊',
      title: 'Contabilidad',
      description: 'Plan de cuentas, transacciones, XML SAT',
    },
    {
      icon: '💰',
      title: 'Financiero',
      description: 'Facturación, pagos, conciliación bancaria',
    },
    {
      icon: '📈',
      title: 'Reportes',
      description: 'Dashboards y reportes financieros',
    },
    {
      icon: '🔔',
      title: 'Notificaciones',
      description: 'Sistema de alertas y mensajería',
    },
  ]

  return (
    <div className="home-page">
      <Container>
        <Row className="text-center mb-5">
          <Col>
            <div className="welcome-section">
              <img
                src="/logo-large.png"
                alt="Arithmos"
                className="welcome-logo mb-4"
                onError={(e) => {
                  e.target.style.display = 'none'
                }}
              />
              <h1 className="display-4 text-primary mb-3">
                Bienvenido a Arithmos
              </h1>
              <p className="lead text-muted mb-4">
                Sistema Contable y Financiero
              </p>
              {!isAuthenticated && (
                <Link to="/login">
                  <Button variant="primary" size="lg" className="me-2">
                    Iniciar Sesión
                  </Button>
                </Link>
              )}
              {isAuthenticated && (
                <Link to="/dashboard">
                  <Button variant="primary" size="lg">
                    Ir al Dashboard
                  </Button>
                </Link>
              )}
            </div>
          </Col>
        </Row>

        <Row className="mb-5">
          <Col>
            <h2 className="text-center text-primary mb-4">Módulos del Sistema</h2>
          </Col>
        </Row>

        <Row>
          {features.map((feature, index) => (
            <Col md={6} lg={4} key={index} className="mb-4">
              <Card className="h-100 feature-card">
                <Card.Body className="text-center">
                  <div className="feature-icon mb-3">{feature.icon}</div>
                  <Card.Title>{feature.title}</Card.Title>
                  <Card.Text className="text-muted">
                    {feature.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Los documentos legales a la vista de todos, con o sin sesión. Son los mismos que acepta
          quien se registra (`/legal/:tipo`, públicas). Sólo aquí, no en cada pantalla. */}
      <nav className="home-legales" aria-label="Documentos legales" data-testid="home-legales">
        {LEGALES.map(({ tipo, nombre }) => (
          <a key={tipo} href={`/legal/${tipo}`} target="_blank" rel="noreferrer">{nombre}</a>
        ))}
      </nav>
    </div>
  )
}

const LEGALES = [
  { tipo: 'aviso_privacidad', nombre: 'Aviso de privacidad' },
  { tipo: 'terminos', nombre: 'Términos y condiciones' },
  { tipo: 'condiciones_uso', nombre: 'Condiciones de uso' },
]

export default Home

